/**
 * Billing configuration helpers for Premium plan copy
 */
import { DEFAULT_BILLING_LOCALE, getBillingLocaleConfig, listBillingLocales } from './billingLocales';

const DEFAULT_TRIAL_DAYS = Number(import.meta.env.VITE_TRIAL_DAYS || '30');
const DEFAULT_ACTIVE_BILLING_LOCALE = import.meta.env.VITE_BILLING_LOCALE || DEFAULT_BILLING_LOCALE;

export const buildPremiumCopy = (locale = DEFAULT_ACTIVE_BILLING_LOCALE) => {
  const localeConfig = getBillingLocaleConfig(locale);
  const trialCopy = `${DEFAULT_TRIAL_DAYS}-day full-access free trial`;
  const pricePerUserPerMonth = localeConfig.pricePerUserPerMonth;
  const summaryCopy = `${trialCopy}. After that it's ${pricePerUserPerMonth}.`;

  return {
    locale,
    localeConfig,
    planName: localeConfig.planName || 'Premium',
    trialDays: DEFAULT_TRIAL_DAYS,
    trialCopy,
    summaryCopy,
    priceDisplay: localeConfig.priceDisplay,
    pricePerUserPerMonth,
    priceLine: {
      price: `${localeConfig.priceDisplay} ${localeConfig.currencyCode}`,
      qualifier: localeConfig.priceQualifier,
    },
    description:
      localeConfig.planDescription ||
      `Enjoy full access for ${DEFAULT_TRIAL_DAYS} days. After that, it's just ${pricePerUserPerMonth}.`,
  };
};

export const getPremiumPriceLine = (locale) => buildPremiumCopy(locale).priceLine;
export const getPremiumPlanDescription = (locale) => buildPremiumCopy(locale).description;

export const AVAILABLE_BILLING_LOCALES = listBillingLocales();

// Legacy constants (fallback to build-time locale). These should only be used as a default.
const FALLBACK_PREMIUM_COPY = buildPremiumCopy();
export const PREMIUM_PLAN_NAME = FALLBACK_PREMIUM_COPY.planName;
export const PREMIUM_TRIAL_DAYS = DEFAULT_TRIAL_DAYS;
export const PREMIUM_PRICE_DISPLAY = FALLBACK_PREMIUM_COPY.priceDisplay;
export const PREMIUM_PRICE_PER_MONTH_PER_USER = FALLBACK_PREMIUM_COPY.pricePerUserPerMonth;
export const PREMIUM_TRIAL_COPY = FALLBACK_PREMIUM_COPY.trialCopy;
export const PREMIUM_SUMMARY_COPY = FALLBACK_PREMIUM_COPY.summaryCopy;
export const PREMIUM_ACTIVE_LOCALE = FALLBACK_PREMIUM_COPY.localeConfig;

export {
  DEFAULT_TRIAL_DAYS,
  DEFAULT_ACTIVE_BILLING_LOCALE,
  DEFAULT_BILLING_LOCALE,
  getBillingLocaleConfig,
  listBillingLocales,
};
